import { render } from "./BaseCard.vue?vue&type=template&id=18915a19&scoped=true"
const script = {}

import "./BaseCard.vue?vue&type=style&index=0&id=18915a19&scoped=true&lang=css"

import exportComponent from "/Users/jj_mac/Documents/find-a-mentor-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18915a19"]])

export default __exports__